import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import PointLocator from '../../algorithm/PointLocator';
import PolygonExtracter from '../../geom/util/PolygonExtracter';
import Location from '../../geom/Location';
import LineString from '../../geom/LineString';
import hasInterface from '../../../../../hasInterface';
import IllegalArgumentException from '../../../../../java/lang/IllegalArgumentException';
import Point from '../../geom/Point';
import Polygon from '../../geom/Polygon';
import GeometryLocation from './GeometryLocation';
import Double from '../../../../../java/lang/Double';
import PointExtracter from '../../geom/util/PointExtracter';
import ConnectedElementLocationFilter from './ConnectedElementLocationFilter';
import LineSegment from '../../geom/LineSegment';
import LinearComponentExtracter from '../../geom/util/LinearComponentExtracter';
import Envelope from '../../geom/Envelope';
import List from '../../../../../java/util/List';
import Distance from '../../algorithm/Distance';
var DistanceOp = /*#__PURE__*/function () {
  function DistanceOp() {
    _classCallCheck(this, DistanceOp);
    DistanceOp.constructor_.apply(this, arguments);
  }
  _createClass(DistanceOp, [{
    key: "computeContainmentDistance",
    value: function computeContainmentDistance() {
      if (arguments.length === 0) {
        var locPtPoly = new Array(2).fill(null);
        this.computeContainmentDistance(0, locPtPoly);
        if (this._minDistance <= this._terminateDistance) return null;
        this.computeContainmentDistance(1, locPtPoly);
      } else if (arguments.length === 2) {
        var polyGeomIndex = arguments[0],
          _locPtPoly = arguments[1];
        var polyGeom = this._geom[polyGeomIndex];
        if (polyGeom.getDimension() < 2) return null;
        var locationsIndex = 1 - polyGeomIndex;
        var polys = PolygonExtracter.getPolygons(polyGeom);
        if (polys.size() > 0) {
          var insideLocs = ConnectedElementLocationFilter.getLocations(this._geom[locationsIndex]);
          this.computeContainmentDistance(insideLocs, polys, _locPtPoly);
          if (this._minDistance <= this._terminateDistance) {
            this._minDistanceLocation[locationsIndex] = _locPtPoly[0];
            this._minDistanceLocation[polyGeomIndex] = _locPtPoly[1];
            return null;
          }
        }
      } else if (arguments.length === 3) {
        if (arguments[2] instanceof Array && hasInterface(arguments[0], List) && hasInterface(arguments[1], List)) {
          var locs = arguments[0],
            _polys = arguments[1],
            _locPtPoly2 = arguments[2];
          for (var i = 0; i < locs.size(); i++) {
            var loc = locs.get(i);
            for (var j = 0; j < _polys.size(); j++) {
              this.computeContainmentDistance(loc, _polys.get(j), _locPtPoly2);
              if (this._minDistance <= this._terminateDistance) return null;
            }
          }
        } else if (arguments[2] instanceof Array && arguments[0] instanceof GeometryLocation && arguments[1] instanceof Polygon) {
          var ptLoc = arguments[0],
            poly = arguments[1],
            _locPtPoly3 = arguments[2];
          var pt = ptLoc.getCoordinate();
          if (Location.EXTERIOR !== this._ptLocator.locate(pt, poly)) {
            this._minDistance = 0.0;
            _locPtPoly3[0] = ptLoc;
            _locPtPoly3[1] = new GeometryLocation(poly, pt);
            return null;
          }
        }
      }
    }
  }, {
    key: "computeMinDistanceLinesPoints",
    value: function computeMinDistanceLinesPoints(lines, points, locGeom) {
      for (var i = 0; i < lines.size(); i++) {
        var line = lines.get(i);
        for (var j = 0; j < points.size(); j++) {
          var pt = points.get(j);
          this.computeMinDistance(line, pt, locGeom);
          if (this._minDistance <= this._terminateDistance) return null;
        }
      }
    }
  }, {
    key: "computeFacetDistance",
    value: function computeFacetDistance() {
      var locGeom = new Array(2).fill(null);
      var lines0 = LinearComponentExtracter.getLines(this._geom[0]);
      var lines1 = LinearComponentExtracter.getLines(this._geom[1]);
      var pts0 = PointExtracter.getPoints(this._geom[0]);
      var pts1 = PointExtracter.getPoints(this._geom[1]);
      this.computeMinDistanceLines(lines0, lines1, locGeom);
      this.updateMinDistance(locGeom, false);
      if (this._minDistance <= this._terminateDistance) return null;
      locGeom[0] = null;
      locGeom[1] = null;
      this.computeMinDistanceLinesPoints(lines0, pts1, locGeom);
      this.updateMinDistance(locGeom, false);
      if (this._minDistance <= this._terminateDistance) return null;
      locGeom[0] = null;
      locGeom[1] = null;
      this.computeMinDistanceLinesPoints(lines1, pts0, locGeom);
      this.updateMinDistance(locGeom, true);
      if (this._minDistance <= this._terminateDistance) return null;
      locGeom[0] = null;
      locGeom[1] = null;
      this.computeMinDistancePoints(pts0, pts1, locGeom);
      this.updateMinDistance(locGeom, false);
    }
  }, {
    key: "nearestLocations",
    value: function nearestLocations() {
      this.computeMinDistance();
      return this._minDistanceLocation;
    }
  }, {
    key: "updateMinDistance",
    value: function updateMinDistance(locGeom, flip) {
      if (locGeom[0] === null) return null;
      if (flip) {
        this._minDistanceLocation[0] = locGeom[1];
        this._minDistanceLocation[1] = locGeom[0];
      } else {
        this._minDistanceLocation[0] = locGeom[0];
        this._minDistanceLocation[1] = locGeom[1];
      }
    }
  }, {
    key: "nearestPoints",
    value: function nearestPoints() {
      this.computeMinDistance();
      var nearestPts = [this._minDistanceLocation[0].getCoordinate(), this._minDistanceLocation[1].getCoordinate()];
      return nearestPts;
    }
  }, {
    key: "computeMinDistance",
    value: function computeMinDistance() {
      if (arguments.length === 0) {
        if (this._minDistanceLocation !== null) return null;
        this._minDistanceLocation = new Array(2).fill(null);
        this.computeContainmentDistance();
        if (this._minDistance <= this._terminateDistance) return null;
        this.computeFacetDistance();
      } else if (arguments.length === 3) {
        if (arguments[2] instanceof Array && arguments[0] instanceof LineString && arguments[1] instanceof Point) {
          var line = arguments[0],
            pt = arguments[1],
            locGeom = arguments[2];
          if (line.getEnvelopeInternal().distance(pt.getEnvelopeInternal()) > this._minDistance) return null;
          var coord0 = line.getCoordinates();
          var coord = pt.getCoordinate();
          for (var i = 0; i < coord0.length - 1; i++) {
            var dist = Distance.pointToSegment(coord, coord0[i], coord0[i + 1]);
            if (dist < this._minDistance) {
              this._minDistance = dist;
              var seg = new LineSegment(coord0[i], coord0[i + 1]);
              var segClosestPoint = seg.closestPoint(coord);
              locGeom[0] = new GeometryLocation(line, i, segClosestPoint);
              locGeom[1] = new GeometryLocation(pt, 0, coord);
            }
            if (this._minDistance <= this._terminateDistance) return null;
          }
        } else if (arguments[2] instanceof Array && arguments[0] instanceof LineString && arguments[1] instanceof LineString) {
          var line0 = arguments[0],
            line1 = arguments[1],
            _locGeom = arguments[2];
          if (line0.getEnvelopeInternal().distance(line1.getEnvelopeInternal()) > this._minDistance) return null;
          var _coord = line0.getCoordinates();
          var coord1 = line1.getCoordinates();
          for (var _i = 0; _i < _coord.length - 1; _i++) {
            var segEnv0 = new Envelope(_coord[_i], _coord[_i + 1]);
            if (segEnv0.distance(line1.getEnvelopeInternal()) > this._minDistance) continue;
            for (var j = 0; j < coord1.length - 1; j++) {
              var segEnv1 = new Envelope(coord1[j], coord1[j + 1]);
              if (segEnv0.distance(segEnv1) > this._minDistance) continue;
              var _dist = Distance.segmentToSegment(_coord[_i], _coord[_i + 1], coord1[j], coord1[j + 1]);
              if (_dist < this._minDistance) {
                this._minDistance = _dist;
                var seg0 = new LineSegment(_coord[_i], _coord[_i + 1]);
                var seg1 = new LineSegment(coord1[j], coord1[j + 1]);
                var closestPt = seg0.closestPoints(seg1);
                _locGeom[0] = new GeometryLocation(line0, _i, closestPt[0]);
                _locGeom[1] = new GeometryLocation(line1, j, closestPt[1]);
              }
              if (this._minDistance <= this._terminateDistance) return null;
            }
          }
        }
      }
    }
  }, {
    key: "computeMinDistancePoints",
    value: function computeMinDistancePoints(points0, points1, locGeom) {
      for (var i = 0; i < points0.size(); i++) {
        var pt0 = points0.get(i);
        for (var j = 0; j < points1.size(); j++) {
          var pt1 = points1.get(j);
          var dist = pt0.getCoordinate().distance(pt1.getCoordinate());
          if (dist < this._minDistance) {
            this._minDistance = dist;
            locGeom[0] = new GeometryLocation(pt0, 0, pt0.getCoordinate());
            locGeom[1] = new GeometryLocation(pt1, 0, pt1.getCoordinate());
          }
          if (this._minDistance <= this._terminateDistance) return null;
        }
      }
    }
  }, {
    key: "distance",
    value: function distance() {
      if (this._geom[0] === null || this._geom[1] === null) throw new IllegalArgumentException('null geometries are not supported');
      if (this._geom[0].isEmpty() || this._geom[1].isEmpty()) return 0.0;
      this.computeMinDistance();
      return this._minDistance;
    }
  }, {
    key: "computeMinDistanceLines",
    value: function computeMinDistanceLines(lines0, lines1, locGeom) {
      for (var i = 0; i < lines0.size(); i++) {
        var line0 = lines0.get(i);
        for (var j = 0; j < lines1.size(); j++) {
          var line1 = lines1.get(j);
          this.computeMinDistance(line0, line1, locGeom);
          if (this._minDistance <= this._terminateDistance) return null;
        }
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._geom = null;
      this._terminateDistance = 0.0;
      this._ptLocator = new PointLocator();
      this._minDistanceLocation = null;
      this._minDistance = Double.MAX_VALUE;
      if (arguments.length === 2) {
        var g0 = arguments[0],
          g1 = arguments[1];
        DistanceOp.constructor_.call(this, g0, g1, 0.0);
      } else if (arguments.length === 3) {
        var _g = arguments[0],
          _g2 = arguments[1],
          terminateDistance = arguments[2];
        this._geom = new Array(2).fill(null);
        this._geom[0] = _g;
        this._geom[1] = _g2;
        this._terminateDistance = terminateDistance;
      }
    }
  }, {
    key: "distance",
    value: function distance(g0, g1) {
      var distOp = new DistanceOp(g0, g1);
      return distOp.distance();
    }
  }, {
    key: "isWithinDistance",
    value: function isWithinDistance(g0, g1, distance) {
      var envDist = g0.getEnvelopeInternal().distance(g1.getEnvelopeInternal());
      if (envDist > distance) return false;
      var distOp = new DistanceOp(g0, g1, distance);
      return distOp.distance() <= distance;
    }
  }, {
    key: "nearestPoints",
    value: function nearestPoints(g0, g1) {
      var distOp = new DistanceOp(g0, g1);
      return distOp.nearestPoints();
    }
  }]);
  return DistanceOp;
}();
export { DistanceOp as default };